import { Typography } from "@material-ui/core"

const MarketplacePage = () => {
    return <div>
        <Typography variant="h3"> Comming soon... </Typography>
    </div>
}

export { MarketplacePage }